export const transparentRed = `rgba(255, 0, 0, 0.1)`;
export const transparentOrange = `rgba(255, 140, 0, 0.2)`;
export const yellow = `#ffff00`

export const makeHexSemiTransparent = (hex: string): string  => `${hex}80`
